import CallControlButtonComponent from './CallControlButton.component';

export * from './CallControlButton.component';
export default CallControlButtonComponent;